exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pagination > li.active > a{\n    background-color:#ccc;\n}\ntable tbody td.action-td{\n    text-align: center;\n    width:120px;\n}\n.action-td .fa{\n    color:#1ab394;\n    font-size: 22px;\n    margin: 10px;\n}\n.action-td .fa .badge{\n    font-size: 10px;\n    color:#fff;\n    position: relative;\n    background-color: #777;\n    top: -10px;\n    margin-left: -14px;\n    border: 1px solid #fff;\n}\n.action-td .fa .badge.has-new{\n    background-color: #ed5565;\n}\n.action-td .fa:hover{\n    font-weight:bold;\n}\n.action-td .fa.fa-fire {\n    color: red;\n}\n.action-td .fa.fa-undo {\n    color: #ff8000;\n}\n.action-td .fa.fa-times-circle {\n    color: red;\n}\n\n.my-drop-zone { border: dotted 3px lightgray; }\n.nv-file-over { border: dotted 3px red; }\n.tabs-container .nav-tabs {\n    border-bottom-width: 0px;\n}\n.value{\n    word-wrap: break-word;\n    max-width: 100%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/assets/styles/v1.css
// module id = 1192
// module chunks = 11